import { FaRegQuestionCircle, FaSearch } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';

import InputMask from 'react-input-mask';
import ReCAPTCHA from 'react-google-recaptcha';
import ReactTooltip from 'react-tooltip';
import { useParams } from 'react-router-dom';
import AnuidadeService from '../../services/AnuidadeService';
import { Container } from './styles';
import Utils from '../../utils';
import colors from '../../styles/colors';
import numeroSegurancaImage from '../../assets/images/numero-seguranca.png';
import { useAnuidade } from '../../hooks/anuidade';

export function Home() {
  const { token } = useParams<{ token?: string }>();

  const {
    anoAnuidade,
    validarAnuidade,
    mensagemAlerta,
    showMensagemOutrasAnuidadesAreaRestrita,
  } = useAnuidade();
  const [validouToken, setValidouToken] = useState(false);
  const isDevelopment = process.env.NODE_ENV === 'development';
  const [inscricao, setInscricao] = useState(isDevelopment ? '159605' : '');
  const [cpf, setCpf] = useState(isDevelopment ? '045.780.266/98' : '');
  const [numeroSeguranca, setNumeroSeguranca] = useState(
    isDevelopment ? '05009110' : '',
  );
  const [recaptcha, setRecaptcha] = useState(isDevelopment ? 'ok' : '');

  function renderMensagemAlerta() {
    const { show, mensagem } = mensagemAlerta;
    if (show) {
      return (
        <div className="row justify-content-md-center base-mensagem-alerta">
          <div className="col col-lg-7">
            <div className="alert alert-warning text-center" role="alert">
              {mensagem}
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
  // function renderAlertaAnuidade2025() {
  //   return (
  //     <div className="row justify-content-md-center base-mensagem-alerta">
  //       <div className="col col-lg-7">
  //         <div className="alert alert-warning text-center" role="alert">
  //           A anuidade 2025 pode ser acessada clicando no link abaixo:
  //           <br />
  //           <a
  //             href="https://anuidade.oabrj.org.br/anuidade/#/?anuidade=2025"
  //             target="_blank"
  //             rel="noreferrer"
  //           >
  //             Clique aqui para acessar a anuidade 2025
  //           </a>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  // function renderAlertaAnuidade2026() {
  //   return (
  //     <div className="row justify-content-md-center base-mensagem-alerta">
  //       <div className="col col-lg-7">
  //         <div className="alert alert-warning text-center" role="alert">
  //           A anuidade 2026 pode ser acessada clicando no link abaixo:
  //           <br />
  //           <a
  //             href="https://anuidade.oabrj.org.br/anuidade/"
  //             target="_blank"
  //             rel="noreferrer"
  //           >
  //             Clique aqui para acessar a anuidade 2026
  //           </a>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  function renderMensagemOutrasAnuidadesAreaRestrita() {
    if (showMensagemOutrasAnuidadesAreaRestrita) {
      return (
        <div className="row justify-content-md-center base-mensagem-alerta">
          <div className="col col-lg-8">
            <div className="alert alert-warning text-center" role="alert">
              Para pagamento de outras anuidades, acesse a área restrita pelo
              link abaixo:
              <br />
              <a
                href="https://arearestrita.oabrj.org.br/"
                target="_blank"
                rel="noreferrer"
              >
                Área Restrita
              </a>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  function onChangeRecaptcha(value: string) {
    setRecaptcha(value);
  }

  function isFormValid(): boolean {
    if (!!inscricao && !!cpf && !!recaptcha) {
      return true;
    }
    return false;
  }

  function handleSubmitForm() {
    validarAnuidade({
      numeroInscricao: Number(inscricao),
      cpf: Utils.removeMask(cpf),
      numeroSeguranca: Number(numeroSeguranca),
    });
  }

  useEffect(() => {
    async function validateToken() {
      if (token) {
        try {
          const dados = await AnuidadeService.validarAcessoToken(
            token,
            anoAnuidade,
          );
          validarAnuidade({
            numeroInscricao: dados.numeroInscricao,
            cpf: Utils.removeMask(dados.cpf),
            numeroSeguranca: Number(dados.numeroSeguranca),
          });
        } catch (e) {
          console.log(e);
        }
      }
      setValidouToken(true);
    }
    validateToken();
  }, []);

  if (!validouToken) {
    return null;
  }

  return (
    <Container>
      <ReactTooltip
        className="numero-seguranca-tooltip"
        type="light"
        border
        place="right"
        effect="solid"
        getContent={() => (
          <div className="numero-seguranca-tooltip-content">
            <p>O que é o número de segurança?</p>
            <div className="info">
              <p>
                Sequência de 8 dígitos que aparecem na parte superior à direita
                do seu cartão de identidade profissional, conforme a figura
                abaixo:
              </p>
              <img src={numeroSegurancaImage} alt="Número segurança" />
            </div>
          </div>
        )}
      />

      {/* {anoAnuidade === 2026 && renderAlertaAnuidade2025()}
      {anoAnuidade !== 2026 && renderAlertaAnuidade2026()} */}

      <div className="col col-lg-7">
        <p className="card-title text-center">
          Preencha os campos abaixo e, em seguida, clique no botão buscar.
        </p>
        <div className="card">
          <div className="card-body">
            <form>
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label text-right">
                  Inscrição:
                </label>
                <div className="col-sm-8">
                  <InputMask
                    mask="99999999999999999999"
                    maskChar=" "
                    className="form-control"
                    value={inscricao}
                    onChange={(e: any) => setInscricao(e.target.value)}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label text-right">
                  CPF:
                </label>
                <div className="col-sm-8">
                  <InputMask
                    mask="999.999.999-99"
                    className="form-control"
                    value={cpf}
                    onChange={(e: any) => setCpf(e.target.value)}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label text-right">
                  <span
                    className="icon-numero-seguranca"
                    data-tip="hello world"
                  >
                    <FaRegQuestionCircle color={colors.secondary} size={20} />
                  </span>
                  Número segurança:
                </label>
                <div className="col-sm-8">
                  <InputMask
                    mask="99999999999999999999"
                    maskChar=" "
                    className="form-control"
                    value={numeroSeguranca}
                    onChange={(e: any) => setNumeroSeguranca(e.target.value)}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-sm-12 container-recaptcha">
                  <ReCAPTCHA
                    sitekey="6LfCIAoUAAAAABi6EqXhgrtoPCv5LB2rXaXNmHzc"
                    onChange={onChangeRecaptcha}
                  />
                </div>
              </div>

              <div className="row justify-content-end">
                <div className="col-sm-3">
                  <button
                    type="button"
                    disabled={!isFormValid()}
                    className="btn btn-danger btn-lg btn-buscar"
                    onClick={handleSubmitForm}
                  >
                    <FaSearch size={20} />
                    Buscar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {renderMensagemAlerta()}
      {renderMensagemOutrasAnuidadesAreaRestrita()}
    </Container>
  );
}
